import { render, staticRenderFns } from "./degreeList.vue?vue&type=template&id=4fa5a9bf&scoped=true"
import script from "./degreeList.vue?vue&type=script&lang=js"
export * from "./degreeList.vue?vue&type=script&lang=js"
import style0 from "./degreeList.vue?vue&type=style&index=0&id=4fa5a9bf&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5a9bf",
  null
  
)

export default component.exports